// Create activity
export const createActivity = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_ACTIVITY',
  payload: { data, successCallback, failCallback }
});

// Set activities list
export const setAllActivities = (payload) => ({
  payload,
  type: 'SET_ALL_ACTIVITIES'
});

// Get single activity
export const getSingleActivity = (payload) => ({
  payload,
  type: 'GET_SINGLE_ACTIVITY'
});

// Set single activity
export const setSingleActivity = (payload) => ({
  payload,
  type: 'SET_SINGLE_ACTIVITY'
});

// Update activity
export const updateActivity = (payload) => ({
  payload,
  type: 'UPDATE_ACTIVITY',
});

// Delete activity
export const deleteActivity = (payload) => ({
  payload,
  type: 'DELETE_ACTIVITY'
});

// Complete activity
export const completeActivity = (payload) => ({
  payload,
  type: 'COMPLETE_ACTIVITY',
});

// Set activity loading
export const setActivityLoading = (payload) => ({
  payload,
  type: 'SET_ACTIVITY_LOADING'
});

// Set activity error
export const setActivityError = (payload) => ({
  payload,
  type: 'SET_ACTIVITY_ERROR'
});

// Toggle activity modal
export const toggleActivityModal = (payload) => ({
  payload,
  type: 'TOGGLE_ACTIVITY_MODAL'
});

// Set activity type
export const setActivityType = (payload) => ({
  payload,
  type: 'SET_ACTIVITY_TYPE'
});

// Update activity form field
export const updateActivityFormField = (field, value) => ({
  type: 'UPDATE_ACTIVITY_FORM_FIELD',
  payload: { field, value }
});

// Reset activity form
export const resetActivityForm = () => ({
  type: 'RESET_ACTIVITY_FORM'
});

// Toggle dropdown
export const toggleDropdown = (payload) => ({
  type: 'TOGGLE_DROPDOWN',
  payload,
});

// Set active activity box
export const setActiveActivityBox = (payload) => ({
  payload,
  type: 'SET_ACTIVE_ACTIVITY_BOX',
});

export const createRelation = (payload) => ({
  payload,
  type: 'CREATE_RELATION',
});

export const getObjectActivities = (payload) => ({
  payload,
  type: 'GET_OBJECT_ACTIVITIES',
})

export const addComment = (payload) => ({
  payload,
  type: 'ADD_COMMENT',
})

export const setEditComment = (payload) => ({
  payload,
  type: 'SET_EDIT_COMMENT',
})

export const updateComment = (payload) => ({
  payload,
  type: 'UPDATE_COMMENT',
})

export const setDeleteComment = (payload) => ({
  payload,
  type: 'SET_DELETE_COMMENT',
})

export const deleteComment = (payload) => ({
  payload,
  type: 'DELETE_COMMENT',
})

// Attachment actions
export const uploadAttachment = (payload) => ({
  payload,
  type: 'UPLOAD_ATTACHMENT',
});

export const setUploadProgress = (fileId, progress) => ({
  type: 'SET_UPLOAD_PROGRESS',
  payload: { fileId, progress }
});

export const uploadAttachmentSuccess = (payload) => ({
  payload,
  type: 'UPLOAD_ATTACHMENT_SUCCESS',
});

export const uploadAttachmentFailure = (payload) => ({
  payload,
  type: 'UPLOAD_ATTACHMENT_FAILURE',
});

export const removeAttachment = (attachmentId) => ({
  payload: attachmentId,
  type: 'REMOVE_ATTACHMENT',
});

export const addPendingAttachment = (file) => ({
  payload: file,
  type: 'ADD_PENDING_ATTACHMENT',
});

export const getActivityAttachments = (activityId) => ({
  payload: activityId,
  type: 'GET_ACTIVITY_ATTACHMENTS',
});

export const setActivityAttachments = (payload) => ({
  payload,
  type: 'SET_ACTIVITY_ATTACHMENTS',
});

export const getObjectAttachments = (objectType, objectId) => ({
  payload: { objectType, objectId },
  type: 'GET_OBJECT_ATTACHMENTS',
});

export const clearPendingAttachments = () => ({
  type: 'CLEAR_PENDING_ATTACHMENTS',
});

// Generic Communication Actions (SMS, Email, WhatsApp, etc.)
// Note: Connection status checking moved to Integration store - use getIntegrationStatus(toolName)

export const getCommunicationHistory = (payload) => ({
  type: 'GET_COMMUNICATION_HISTORY',
  payload // { channel, identifier } - identifier is phone/email
});

export const setCommunicationHistory = (payload) => ({
  type: 'SET_COMMUNICATION_HISTORY',
  payload // { channel, messages }
});

export const sendCommunication = (payload) => ({
  type: 'SEND_COMMUNICATION',
  payload // { channel, contactId, to, message, ... }
});

export const addCommunicationMessage = (payload) => ({
  type: 'ADD_COMMUNICATION_MESSAGE',
  payload // { channel, message }
});

export const setCommunicationLoading = (payload) => ({
  type: 'SET_COMMUNICATION_LOADING',
  payload // { channel, loading }
});

export const setCommunicationSending = (payload) => ({
  type: 'SET_COMMUNICATION_SENDING',
  payload // { channel, sending }
});

// Get communication resources (agents, phones for calls)
export const getCommunicationResources = (channel) => ({
  type: 'GET_COMMUNICATION_RESOURCES',
  payload: { channel }
});

export const setCommunicationResources = (payload) => ({
  type: 'SET_COMMUNICATION_RESOURCES',
  payload // { channel, agents, phones }
});